import { reactive } from '@vue/composition-api'

const languageState = reactive({
  activeLang: 'English'
})

export default languageState
